import type { KhoanThu as IKhoanThu } from '@/services/KhoanThu';
import { getDetailHocPhi, getDetailKhoanThu, getKhoanThu, getHangMuc } from '@/services/KhoanThu/khoanthu';
import { useState } from 'react';
import { DataDetailNhapTay } from '@/services/KhoanThu';

export default () => {
  const [danhSach, setDanhSach] = useState<IKhoanThu.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<IKhoanThu.Record>({} as any);
  const [totalThu, setTotalThu] = useState<number>(1);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>();
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [dataDetail, setDataDetail] = useState<IKhoanThu.DataDetailHocPhi[]>([]);
  const [dataDetailNhapTay, setDataDetailNhapTay] = useState<IKhoanThu.DataDetailNhapTay[]>();
  const [isNhapTay, setIsNhapTay] = useState<boolean>(false);
  const [totalDoanhThu, setTotalDoanhThu] = useState<any>()
  const [danhSachAll, setDanhSachAll] = useState<IKhoanThu.Record[]>([]);

  const getKhoanThuModel = async (donViId?: string, condition?: any) => {
    setLoading(true);
    if (condition) {
      // setCondition({...cond,...condition})
      const sort = { module: -1 };
      const dataHangMucThu = await getHangMuc({ page: 1, limit: 1000, cond: condition, donViId, sort });
      const dataKhoanThu = await getKhoanThu({ page: 1, limit: 1000, cond: {...condition, loaiDoanhThu: 'Khác'}, donViId, sort });
      let rsHangMucThu = dataHangMucThu?.data?.data?.result.map((data: any) =>  {
        let tempData = {
          ...data,
          ten: data.tenHangMuc,
          soTien: data.soTienThucTe,
          children: data.childrenList.length > 0 ? data.childrenList : null,
          key: data.id
        }
        delete tempData.childrenList
        return tempData;
      })
      let rsKhoanThu = dataKhoanThu.data?.data?.result.map((data: any) => {
        let tempData = {
          ...data,
          createAt: data.createAt,
          loai: data.loaiDoanhThu
        }
        return tempData;
      })
      let resultAll = [...rsKhoanThu, ...rsHangMucThu]
      setDanhSachAll(resultAll ?? [])
      const resultPageable = resultAll?.length > limit ? getPageableResult(resultAll, page, limit) : resultAll;
      setDanhSach(resultPageable ?? []);
      setTotal((dataHangMucThu?.data?.data?.total + dataKhoanThu?.data?.data?.total) ?? 0);
      setLoading(false);

      let totalKhoanThu: number = 0;
      let totalSoTienDuKien = 0;
      let totalSoTienThucTe = 0;
      resultAll?.forEach((item: { soTien: number, soTienDuKien: number }) => {
        totalKhoanThu += item?.soTien;
        totalSoTienDuKien += item?.soTienDuKien;
        totalSoTienThucTe += item?.soTien;
        return totalKhoanThu;
      });
      setTotalThu(totalKhoanThu);
      const total = {
        "soTienDuKien": totalSoTienDuKien,
        "soTienThucTe":totalSoTienThucTe
      }
      setTotalDoanhThu(total)
    }
  };

  const getPageableResult = (resultAll: any[], page: number, limit: number) => {
    if (!resultAll || resultAll.length === 0) return [];
  
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
  
    return resultAll.slice(startIndex, endIndex);
  };

  const getDetailKhoanThuModel = async (
    thang: number,
    nam: number,
    donViId?: string,
    condition?: any,
  ) => {
    setLoading(true);
    const response = await getDetailHocPhi({ thang, nam, condition, donViId });
    setLoading(false);
    setDataDetail(response?.data?.data);
  };
  const getDetail = async (id: string) => {
    setLoading(true);
    const response = await getDetailKhoanThu({ id });
    setLoading(false);
    const arr: IKhoanThu.DataDetailNhapTay[] = [];
    arr.push(response?.data?.data);
    setDataDetailNhapTay(arr);
  };
  return {
    danhSach,
    totalDoanhThu,
    record,
    setRecord,
    loading,
    setLoading,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    getKhoanThuModel,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    totalThu,
    getDetailKhoanThuModel,
    dataDetail,
    getDetail,
    dataDetailNhapTay,
    isNhapTay,
    setIsNhapTay,
    danhSachAll
  };
};
